import {isUndefined} from "lodash-es";
import {serialize, deserialize} from "../../utilities/serializer";

export class NfMessage {
    public NfMessage = true;
    public type: NfMessageType;
    /**
     * Do tych callbacków automatycznie rejestrują się wszystkie typy wiadomości i wypełniają je własnymi faktorkami,
     * robią to w swoich odpowiednich plikach ts
     */
    public static creationCallbacks: {[messageType in NfMessageType]?: (event: MessageEvent) => NfMessage|null} = {};
    public static createFromEvent(event: MessageEvent): NfMessage|null {
        if(typeof(event.data) === 'object' && event.data.NfMessage) {
            const type = event.data.type as NfMessageType;
            const creationCallback = NfMessage.creationCallbacks[type];
            if(typeof (creationCallback) === 'function') {
                return creationCallback(event);
            }
            const message = new NfMessage(event.data.type);
            Object.assign(message,event.data);
            return message;
        }
        return null;
    }

    /**
     * Sprawdza czy obiekt jest wiadomością, w zależności od środowiska (worker lub strona internetowa) sprawdzi odpowiedni typ
     * @param object
     */
    public static isMessageEvent(object: any|MessageEvent): object is MessageEvent {
        return object && typeof(object) === 'object' && (!isUndefined(self['ExtendableMessageEvent']) && object instanceof ExtendableMessageEvent || !isUndefined(self['MessageEvent']) && object.constructor.name == 'MessageEvent');
    }
    public constructor(type: NfMessageType) {
        this.type = type;
    }

    /**
     * Serializacja pod używanie przez postMessage (które jest używane do komunikacji z service workerem)
     * Obiekty zawierające np. momenty, powinny zostać zserializowane przy użyciu tej funkcji przed wysłaniem wiadomości
     * @param element
     */
    public serialize(element: any) {
        return serialize(element);
    }

    /**
     * Deserializacja po przejściu przez postmessage
     * @param element
     */
    public deserialize(element: any) {
        return deserialize(element);
    }

}

/**
 * Lista dostępnych rodzajów wiadomości
 * Uwaga - nie zmieniać ich kolejności, nie usuwać, dodawać tylko na końcu, nie podmieniać numerów
 */
export enum NfMessageType {
    ServiceWorkerActivated=0,
    /**
     * Gdy service worker jest przeładowywany
     */
    ServiceWorkerReloading=1,
    /**
     * Po tym jak service worker został przeładowany, żąda od komponentów ponownej rejestracji
     */
    RequestComponentRefresh=2,
    /**
     * Ponowna rejestracja komponentów w service workerze
     */
    ComponentRefresh=3,
    /**
     * Gdy nowa instancja booking engine się podłącza, wysyła tą wiadomość
     */
    ActivateNewBookingEngine=4,
    /**
     * Service worker wysyła wszystkim komponentom id zakładki, w której się znajdują
     */
    SetBrowserTabId=5,
    /**
     * Gdy nowy komponent booking engine się podłącza, wysyła tą wiadomość
     */
    ActivateNewBookingEngineComponent=6,
    /**
     * Poinformowanie komponentu o przyznaniu mu id
     */
    SetComponentId=7,
    /**
     * Poinformowanie komponentu o przyznaniu mu id instancji booking engine (dla nowych instancji)
     */
    SetServiceInstanceId=8,
    /**
     * Prośba o załadowanie konfiguracji booking engine
     */
    GetBookingEngineConfiguration=9,
    GetBookingEngineConfigurationResult=10,
    /**
     * Prośba o załadowanie przetłumaczonych nazw w booking engine
     */
    GetHotelTranslatedConfiguration=11,
    GetHotelTranslatedConfigurationResult=12,
    /**
     * Prośba o załadowanie translacji
     */
    GetTranslations=13,
    GetTranslationsResult=14,
    /**
     * Prośba o załadowanie styli
     */
    GetStyles=15,
    GetStylesResult=16,
    SetLanguage=17,
    SetReservationSearchData=18,
    GetReservationSearchData=19,
    GetBrowserTabId=20,
    GetAvailability=21,
    AvailabilityData=22,
    ComponentRemoved=23,
    GetEquipmentDescriptions=24,
    GetEquipmentDescriptionsResult=25,
    NewModalRequest=26,
    NavigateRequest=27,
    Navigated=28,
    GetShop=29,
    GetShopResult=30,
    SetShopChosen=31,
    GetShopChosen=32,
    GetReservationCalculation=33,
    GetReservationCalculationResult=34,
    GetRoomStandards=35,
    RoomStandardData=36,
    SetCustomerData=37,
    SetOfferChosen=38,
    SetRoomStandardChosen=39,
    SetBookingChosen=40,
    SetBookingResult=41,
    CheckBookingPossible=42,
    CheckBookingPossibleResult=43,
    ShareRequest=44,
    SetShoppingCart=45,
    /**
     * Ustawienie koszyka rezerwacji dla grupy rezerwacji
     */
    SetGroupReservationBasket = 46,
    SetPaymentData=47,
    SetGroupBookingResult = 48,
    SetInstanceConfiguration = 49,
    /**
     * Wiadomość, aby przeładować widgeta (np. po zmianie języka)
     */
    ReloadBookingEngine = 50,
    AvailabilitySearchStarted = 51

}